export const en = {
    Feedback: {
        sentiment: {
            positive: "Positive",
            constructive: "Constructive",
            neutral: "Neutral"
        },
        metric: {
            recognition: "Recognition",
            feedback: "Feedback",
            relationshipWithPeers: "Relationship with peers",
            relationshipWithManager: "Relationship with manager",
            satisfaction: "Satisfaction",
            alignment: "Alignment",
            happiness: "Happiness",
            wellness: "Wellness",
            personalGrowth: "Personal growth",
            ambassadorship: "Ambassadorship"
        },
        source: {
            officevibe: "Pulse survey: Officevibe questions",
            custom: "Pulse survey: custom questions",
            onboarding: "Onboarding survey",
            smart: "Smart questions",
            nonSurvey: "Non-survey"
        },
        date: {
            week: "Week of {{date}}",
            absolute: "{{date}}"
        },
        status: {
            replied: "Replied"
        },
        outboxSender: {
            you: "You",
            anonymous: "You (anonymous)"
        }
    },
    SuggestionComposeDialog: {
        title: "Give feedback",
        close: "Close",
        liveRegion: {
            limitReached: "Character limit reached."
        },
        recipient: {
            label: "To",
            name: "Suggestion box",
            subtitleAnonymous: "Anonymous, shared with leadership",
            subtitleIdentified: "Shared with leadership"
        },
        message: {
            label: "What's your feedback?",
            placeholder: "Share what's on your mind. Be specific about what happened and what would help.",
            charactersLeft_one: "{{count}} character left",
            charactersLeft_other: "{{count}} characters left"
        },
        identity: {
            label: "How to send this feedback",
            selfLabel: "Send as yourself",
            selfDescription: "Leadership will see your name with this feedback.",
            anonymousLabel: "Send anonymously",
            anonymousDescription: "Leadership won't see who sent this."
        },
        footer: {
            anonymous: "Sending anonymously",
            from: "From {{name}}"
        },
        cancel: "Cancel",
        submit: "Send feedback",
        discardChangesTitle: "Discard this feedback?",
        discardChangesBody: "You have not sent this yet. Leaving now will lose what you have written.",
        discardChangesConfirmLabel: "Discard",
        discardChangesCancelLabel: "Keep editing",
        successToast: "Feedback sent",
        errorToast: "Couldn't send your feedback. Please try again."
    }
};
